import React from 'react';
import { Outlet } from "react-router-dom";
import NavBar from './components/NavBar';
import Footer from './components/Footer';
class HomePage extends React.Component {

  render() {


    return (

      <React.Fragment >

        <div className='div-firstpage' >

          <NavBar />

          <Outlet /> 

          <Footer />

        </div>

      </React.Fragment>

    )

  }

}


export default HomePage;
